import * as yup from 'yup'

const schema = yup.object().shape({
  dataAction: yup.string().required(),
})

export default schema
